import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import FR from "./locales/fr.json";
import EN from "./locales/en.json";
import ES from "./locales/es.json";

i18n.use(initReactI18next).init({
  resources: {
    FR: { translation: FR },
    EN: { translation: EN },
    ES: { translation: ES },
  },
  lng: localStorage.getItem("lang") || "FR" ,
  fallbackLng: "FR",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;